import { render, staticRenderFns } from "./AdminProductColor.vue?vue&type=template&id=323ef4d1&scoped=true&"
import script from "./AdminProductColor.vue?vue&type=script&lang=js&"
export * from "./AdminProductColor.vue?vue&type=script&lang=js&"
import style0 from "./AdminProductColor.vue?vue&type=style&index=0&id=323ef4d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323ef4d1",
  null
  
)

export default component.exports